import { render } from "./WCItemModifier.vue?vue&type=template&id=907d7b1c&scoped=true"
import script from "./WCItemModifier.vue?vue&type=script&lang=js"
export * from "./WCItemModifier.vue?vue&type=script&lang=js"

import "./WCItemModifier.vue?vue&type=style&index=0&id=907d7b1c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-907d7b1c"]])

export default __exports__